import {
  DateRangePicker,
  DateRange,
} from '@mui/x-date-pickers-pro/DateRangePicker';
import { Box, TextField } from '@mui/material';
import React from 'react';
import { Control, Controller, FieldErrors, FieldValues } from 'react-hook-form';

export const DateRangeField = function ({
  id,
  name,
  label,
  control,
  startLabel,
  endLabel,
  disablePast,
  errors,
  minDate,
  maxDate,
}: {
  id: string;
  name: string;
  label: string;
  control: Control<FieldValues>;
  format?: string;
  startLabel?: string;
  endLabel?: string;
  disablePast?: boolean;
  errors?: FieldErrors | null;
  minDate?: Date;
  maxDate?: Date;
}) {
  const [open, setOpen] = React.useState(false);
  const [isAccept, setIsAccept] = React.useState(false);
  const [isTextField, setIsTextField] = React.useState(false);

  const createTitle = (text: string) => {
    const result = text.replace(/([A-Z])/g, ' $1');
    return result.charAt(0).toUpperCase() + result.slice(1);
  };

  return (
    <Controller
      rules={{ required: true }}
      control={control}
      name={name}
      render={({ field: { onChange, value } }) => {
        return (
          <DateRangePicker
            open={open}
            minDate={minDate ?? undefined}
            maxDate={maxDate ?? undefined}
            onAccept={() => {
              setIsAccept(true);
            }}
            onClose={() => {
              setIsAccept(false);
              if (!isTextField) {
                setOpen(false);
                setIsTextField(false);
              }
            }}
            onOpen={() => {
              if (!isAccept) {
                setOpen(true);
              }
            }}
            disablePast={disablePast}
            calendars={1}
            label={label}
            value={value}
            onChange={(date: DateRange<unknown>) => onChange(date)}
            renderInput={(startProps, endProps) => {
              return (
                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignSelf: 'center',
                    width: '100%',
                  }}
                >
                  <TextField
                    {...startProps}
                    sx={{
                      flex: 2,
                    }}
                    variant="standard"
                    label={(startLabel && createTitle(startLabel)) || 'start'}
                    error={!!errors && !!errors[id]?.message}
                    helperText={!!errors && errors[id]?.message}
                    onFocus={() => {
                      setIsTextField(true);
                    }}
                    onBlur={() => {
                      setIsTextField(false);
                    }}
                    onClick={() => {
                      setOpen(true);
                    }}
                  />
                  <Box
                    sx={{
                      px: 2,
                      display: 'flex',
                      alignItems: 'flex-end',
                      justifyContent: 'center',
                    }}
                  >
                    to
                  </Box>
                  <TextField
                    {...endProps}
                    sx={{
                      flex: 2,
                    }}
                    label={(endLabel && createTitle(endLabel)) || 'end'}
                    error={!!errors && !!errors[id]?.message}
                    variant="standard"
                    onFocus={() => {
                      setIsTextField(true);
                    }}
                    onBlur={() => {
                      setIsTextField(false);
                    }}
                    onClick={() => {
                      setOpen(true);
                    }}
                  />
                </div>
              );
            }}
          />
        );
      }}
    />
  );
};
